import { createFileRoute } from '@tanstack/react-router';
import IntegrationApp from '../admin/integration-apps/view';
export const Route = createFileRoute('/admin/integrations/apps')({ component: IntegrationApp });
